var _rect, _rect2, _path, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInternationalPassport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 64,
    viewBox: "0 0 46 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.01,
    width: 36.201,
    height: 56,
    rx: 4,
    transform: "rotate(-7.956 1 6.01)",
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.011,
    width: 44,
    height: 56,
    rx: 4,
    fill: "#fff",
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.876 31.42l-2.903-1.459a.855.855 0 01-.458-.626.855.855 0 01.239-.738l.444-.444a.853.853 0 01.63-.25l2.995.095 1.446-1.446-5.58-3.4a.849.849 0 01-.158-1.32c.143-.14.283-.28.402-.4a.846.846 0 01.771-.23l7.788 2.127 2.807-2.807a1.75 1.75 0 012.473 0 1.75 1.75 0 010 2.474l-2.807 2.807 2.127 7.788a.845.845 0 01-.23.771l-.4.401a.848.848 0 01-1.32-.158l-3.4-5.58-1.444 1.445.098 2.991a.855.855 0 01-.248.63l-.45.45a.855.855 0 01-.739.239.855.855 0 01-.626-.459l-1.457-2.902z",
    fill: "#2C2D2E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.284,
    y: 49.056,
    width: 14.25,
    height: 2.591,
    rx: 1.295,
    fill: "#2C2D2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.284,
    y: 43.874,
    width: 19.432,
    height: 2.591,
    rx: 1.295,
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgInternationalPassport as ReactComponent };